function BilledStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#EEF0F9] font-OpenSansSemiBold font-[600] text-[#5F6477] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Billed
    </div>
  );
}

export default BilledStatus;
